import React from 'react'

import { AlertWithActionsType, AlertWithActions } from '@masfront/common-b2c'

import { Box, Typography, makeStyles } from '@material-ui/core'

import useSelectedBundles from './useSelectedBundles'

import { SelectedBundlesProps, BundleType } from '../../model/bundles.model'

const useStyles = makeStyles({
  root: {
    '& .link': {
      zIndex: 2,
    },
    '& .MuiAlert-root': {
      '@media (max-width: 1210px)': {
        minWidth: '500px',
      },
      minWidth: '670px',
    },
  },
})

export default function SelectedBundles({ id, dataHook, type }: SelectedBundlesProps) {
  const { selectedBundles, onDeleteBundle } = useSelectedBundles(id, type)

  const isBonus = type === BundleType.BONUS

  const { root } = useStyles()

  return (
    <Box data-hook={dataHook} className={root}>
      {selectedBundles.map((bundle) => (
        <Box pb={4} data-hook={`${dataHook}-${bundle.id}`} key={`${dataHook}-${bundle.id}`}>
          <AlertWithActions
            type={isBonus ? AlertWithActionsType.warning : AlertWithActionsType.info}
            actions={[{ name: 'Eliminar', fn: () => onDeleteBundle(bundle.id) }]}
          >
            <Box display="flex">
              <Box pr={3}>
                <Typography variant="body1">{bundle.name}</Typography>
              </Box>
              <Box pr={3}>
                <Typography variant="body1">
                  {bundle.durationText.map((text) => (
                    <span key={`selected-bundles-price-${text.payment}`}>
                      {text.pretext}
                      <strong>{text.payment}</strong>
                      {text.duration}
                    </span>
                  ))}
                </Typography>
              </Box>
            </Box>
          </AlertWithActions>
        </Box>
      ))}
    </Box>
  )
}
